document.querySelectorAll('.js-smooth-anchor').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
        e.preventDefault()
        const hash = anchor.getAttribute('href')
        console.log(hash)
        const target = document.querySelector(hash)

        target.scrollIntoView({
            behavior: 'smooth',
        })

        window.history.pushState(null, null, hash)
    })
})
